import { render } from "./WorkspaceDataCloneDialog.vue?vue&type=template&id=0953137f&scoped=true&ts=true"
import script from "./WorkspaceDataCloneDialog.vue?vue&type=script&lang=ts"
export * from "./WorkspaceDataCloneDialog.vue?vue&type=script&lang=ts"

import "./WorkspaceDataCloneDialog.vue?vue&type=style&index=0&id=0953137f&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0953137f"]])

export default __exports__